import { render, staticRenderFns } from "./TopBrands.vue?vue&type=template&id=4db7e38a&"
import script from "./TopBrands.vue?vue&type=script&lang=js&"
export * from "./TopBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports